import React from 'react';

export default function StatCard({ icon, label, value, color, bg }) {
  return (
    <div style={{
      background:   'white',
      borderRadius: 16,
      padding:      '20px 24px',
      boxShadow:    '0 2px 12px rgba(0,0,0,0.06)',
      display:      'flex',
      alignItems:   'center',
      gap:          16,
      border:       '1px solid #f0f0f0',
      transition:   'box-shadow 0.2s',
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.1)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.06)'}
    >
      <div style={{
        width:        48,
        height:       48,
        borderRadius: 14,
        background:   bg,
        display:      'flex',
        alignItems:   'center',
        justifyContent: 'center',
        fontSize:     22,
        flexShrink:   0,
      }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 26, fontWeight: 800, color, lineHeight: 1.1 }}>{value}</div>
        <div style={{ fontSize: 13, color: '#64748b', fontWeight: 500, marginTop: 2 }}>{label}</div>
      </div>
    </div>
  );
}
